"use client";

import { DirectusImage } from "@/components/DirectusImage";
import Title from "@/components/ui/title";
import { getDecimals } from "@/lib/utils";
import CountUp from "react-countup";

export default function ResearchInnovation(props: {
  data?: {
    title?: string;
    description?: string;
    data_list?: {
      name?: string;
      value?: number;
      unit?: string;
      icon?: string;
    }[];
  }
}) {
  return (
    <div className="w-full">
      {props.data?.title && (
        <Title className="font-semibold" title={props.data?.title} underline={false} />
      )}
      <p className="mt-4 text-center text-sm md:mt-3 md:text-base md:whitespace-pre-line">
        {props.data?.description}
      </p>
      <div className="w-full mt-5 grid grid-cols-1 gap-y-4 md:mt-10 md:grid-cols-2 md:gap-x-10 lg:grid-cols-4">
        {props.data?.data_list?.map((el ,index) => (
          <div
            key={index}
            className="flex py-4 rounded-lg md:py-9 md:justify-center max-md:px-5 md:rounded-xl md:duration-300 md:hover:bg-white md:hover:shadow-md max-md:bg-white"
          >
            <div className="flex md:flex-col md:min-w-[200px] max-md:flex-auto max-md:justify-between max-md:items-end text-center">
              <span className="text-zinc-600 text-4xl md:text-5xl md:leading-tight">
                <span className="relative">
                  <CountUp
                    start={0}
                    end={el.value || 0}
                    decimals={getDecimals(el.value || 0)}
                    separator={""}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                  {el.unit && (
                    <span className="absolute -right-1.5 text-xs md:-right-3 md:-top-1 md:text-base">{el.unit}</span>
                  )}
                </span>
              </span>
              <span className="text-zinc-400 text-sm md:mt-2 md:text-base">{el.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
